import axios from '../../config/axiosConfig';
import { API_BASE_URL } from '../../config/ApiConfig';

// Módulos do sistema
export const MODULOS = [
  { key: 'despesas', label: 'Despesas' },
  { key: 'receitas', label: 'Receitas' },
  { key: 'pessoas', label: 'Pessoas' },
  { key: 'contas', label: 'Contas' },
  { key: 'orcamentos', label: 'Orçamentos' },
  { key: 'programas', label: 'Programas' },
  { key: 'acoes', label: 'Ações' },
  { key: 'subacoes', label: 'Sub-ações' },
  { key: 'favorecidos', label: 'Favorecidos' },
  { key: 'redistribuicoes', label: 'Redistribuições' },
  { key: 'rendimentos', label: 'Rendimentos' },
  { key: 'saldos', label: 'Saldos' },
  { key: 'saldos_investimento', label: 'Saldos de Investimento' },
  { key: 'bancos', label: 'Bancos' },
  { key: 'fontes_recurso', label: 'Fontes de Recurso' },
  { key: 'elemento_despesa', label: 'Elemento de Despesa' },
  { key: 'associacoes', label: 'Associações' },
  { key: 'usuarios', label: 'Usuários' },
  { key: 'relatorios', label: 'Relatórios' },
  { key: 'monitoramento', label: 'Monitoramento' },
  { key: 'contas_programas', label: 'Conta-Programa' },
];

// Cache local de permissões
let permissoesCache = {};

/**
 * Busca permissões do backend e armazena em cache
 */
export async function carregarPermissoes(cpf, cnpj) {
  try {
    console.log('🔵 Carregando permissões:', { cpf, cnpj });
    const response = await axios.get(`${API_BASE_URL.PERMISSAO}/map?cpf=${cpf}&cnpj=${cnpj}`);
    console.log('✅ Permissões carregadas:', response.data);
    permissoesCache[`${cpf}_${cnpj}`] = response.data;
    return response.data;
  } catch (error) {
    console.error('❌ Erro ao carregar permissões:', error);
    console.error('Detalhes do erro:', error.response?.data);
    return {};
  }
}

/**
 * Busca permissões do cache ou do backend
 */
export async function getPermissoesForCnpj(cpf, cnpj) {
  const cacheKey = `${cpf}_${cnpj}`;
  if (permissoesCache[cacheKey]) {
    return permissoesCache[cacheKey];
  }
  return await carregarPermissoes(cpf, cnpj);
}

/**
 * Salva permissões no backend
 */
export async function savePermissoesForCnpj(cpf, cnpj, permissoes) {
  try {
    // Converte objeto de permissões para array
    // Se um módulo não está em 'permissoes', usa valores padrão (todos true)
    const permissoesArray = MODULOS.map(modulo => {
      const permsModulo = permissoes[modulo.key] || {};
      return {
        modulo: modulo.key,
        abrir: permsModulo.abrir !== false,
        criar: permsModulo.criar !== false,
        editar: permsModulo.editar !== false,
        excluir: permsModulo.excluir !== false,
        exportar: permsModulo.exportar !== false,
      };
    });

    console.log('🔵 ESTADO COMPLETO antes de salvar:');
    console.log('   perms object:', JSON.stringify(permissoes, null, 2));
    console.log('🔵 ARRAY que será enviado:');
    permissoesArray.forEach(p => {
      if (!p.abrir || !p.criar || !p.editar || !p.excluir || !p.exportar) {
        console.log(`   ⚠️ ${p.modulo}: abrir=${p.abrir}, criar=${p.criar}, editar=${p.editar}, excluir=${p.excluir}, exportar=${p.exportar}`);
      }
    });

    console.log('🔵 Salvando permissões:', {
      cpf,
      cnpj,
      url: `${API_BASE_URL.PERMISSAO}/salvar?cpf=${cpf}&cnpj=${cnpj}`,
      total: permissoesArray.length
    });

    const response = await axios.post(`${API_BASE_URL.PERMISSAO}/salvar?cpf=${cpf}&cnpj=${cnpj}`, permissoesArray);
    
    console.log('✅ Permissões salvas com sucesso:', response.data);
    
    // Atualiza cache
    permissoesCache[`${cpf}_${cnpj}`] = permissoes;
    
    return true;
  } catch (error) {
    console.error('❌ Erro ao salvar permissões:', error);
    console.error('Detalhes do erro:', error.response?.data);
    return false;
  }
}

/**
 * Verifica se tem permissão para uma ação em um módulo
 */
export async function hasPermission(cpf, cnpj, modulo, acao) {
  const permissoes = await getPermissoesForCnpj(cpf, cnpj);
  
  // Se não há permissão configurada para o módulo, permite por padrão
  if (!permissoes[modulo]) {
    return true;
  }
  
  const perm = permissoes[modulo];
  switch (acao.toLowerCase()) {
    case 'abrir':
    case 'open':
    case 'view':
      return perm.abrir !== false;
    case 'criar':
    case 'create':
      return perm.criar !== false;
    case 'editar':
    case 'edit':
      return perm.editar !== false;
    case 'excluir':
    case 'delete':
      return perm.excluir !== false;
    case 'exportar':
    case 'export':
      return perm.exportar !== false;
    default:
      return false;
  }
}

/**
 * Limpa cache de permissões
 */
export function limparCachePermissoes() {
  permissoesCache = {};
}

